import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '240px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  colorInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '16px',
  },
  colorPreview: {
    width: '32px',
    height: '32px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    flexShrink: 0,
  },
  inputContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 8px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
  },
  inputLabel: {
    color: '#666',
    fontSize: '14px',
  },
  hexInput: {
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    fontSize: '14px',
    width: '60px',
    fontFamily: 'monospace',
    textTransform: 'uppercase',
  },
  opacityInput: {
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    fontSize: '14px',
    width: '30px',
    textAlign: 'right',
    marginLeft: 'auto',
  },
  section: {
    marginBottom: '16px',
  },
  sectionTitle: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '8px',
  },
  sectionTitleWithSelect: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  colorGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: '8px',
  },
  colorGridTheme: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '8px',
    paddingLeft: '20%',
    paddingRight: '20%',
  },
  colorButton: {
    width: '100%',
    aspectRatio: '1',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    padding: 0,
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  colorButtonSelected: {
    border: '2px solid #000',
  },
  emptyColorButtonSelected: {
    border: '2px solid transparent',
  },
  colorButtonDefault: {
    border: '1px solid #e0e0e0',
  },
  themeSelect: {
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '2px 20px 2px 6px',
    fontSize: '12px',
    backgroundColor: 'white',
    cursor: 'pointer',
    outline: 'none',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 4px center',
    backgroundSize: '16px',
    width: '100%',
  },
}));

export default useStyles;
